// extracted by mini-css-extract-plugin
export var base = "SubtleButton-module--base--ec853";
export var bullet = "SubtleButton-module--bullet--fe6e3";
export var center = "SubtleButton-module--center--220b1";
export var left = "SubtleButton-module--left--94f38";
export var radiusNone = "SubtleButton-module--radiusNone--f4ee2";
export var right = "SubtleButton-module--right--5a0b8";